import React, { Component } from 'react';

import Helmet from './Helmet';

const Title = 'Aha Alternative | Canny';
const Description =
  'Canny is a modern Aha Ideas alternative, built specifically to gather, track, and manage user feedback. Get started for free!';
const Image = 'https://canny.io/images/canny-social.png';

export default class LandingAhaHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: 'https://canny.io/compare/aha' },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}
      />
    );
  }
}
